import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const QuestionLibrary = lazy(() =>
  import(/* webpackChunkName: "QuestionLibrary" */ '../../components/survey_editor/question_library/QuestionLibrary')
);

export default function QuestionLibraryComponent({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <QuestionLibrary {...props} />
    </Suspense>
  );
}
